"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Pc = _interopRequireDefault(require("@rsuite/icon-font/lib/device/Pc"));

// Generated by script, don't edit it please.
var Pc = (0, _createSvgIcon["default"])({
  as: _Pc["default"],
  ariaLabel: 'pc',
  category: 'device',
  displayName: 'Pc'
});
var _default = Pc;
exports["default"] = _default;
module.exports = exports.default;